import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { RoutePermissionResolver } from '@app/@core/router/route-permission.resolver';
import { PrimengModule } from '@app/shared/modules/primeng.module';
import { SharedModule } from '@app/shared/shared.module';
// import { InAppMessageAccessGuard } from '@app/guards/in-app-message-access.guard';

// Components
import { InAppMessageComponent } from './in-app-message.component';
// import { InboxListingComponent } from './inbox-listing/inbox-listing.component';
// import { MessageDetailsComponent } from './message-details/message-details.component';
// import { NewMessageComponent } from './new-message/new-message.component';
// import { SentListingComponent } from './sent-listing/sent-listing.component';
// import { DraftListingComponent } from './draft-listing/draft-listing.component';
// import { ArchiveListingComponent } from './archive-listing/archive-listing.component'; 

// Pipes
import { 
  AvatarBackgroundColorPipe,
  AvatarInitialsPipe, 
  IsAvatarImagePipe,
  PriorityClassPipe,
  StatusClassPipe,
  StatusIconPipe
} from './@core/pipes';

// Services
import { InAppMessageService } from './in-app-message.service';
import { SharedPipesModule } from '@app/@core/pipes/shared-pipes.module';
import { InAppMessagingModule } from '@pics-core/in-app-messaging';
import { environment } from '@env/environment';
import { EXTERNAL_COMPONENTS } from '@pics-core/common-utils';
import { solutionComponents } from '@app/shared/features/custom-solution/solution-wrapper-module';

const routes: Routes = [
  {
    path: ':applicationId',
    component: InAppMessageComponent,
    // canActivate: [InAppMessageAccessGuard],
    data: {
      rootmodulenames: ['CASE_INBOX'],
      route: '/case-inbox'
    },
    // resolve: { permissions: RoutePermissionResolver }
  }
];

@NgModule({
  declarations: [
    InAppMessageComponent,
    // InboxListingComponent,
    // MessageDetailsComponent,
    // NewMessageComponent,
    // SentListingComponent,
    // DraftListingComponent,
    // ArchiveListingComponent,
    // Pipes
    AvatarBackgroundColorPipe,
    AvatarInitialsPipe,
    IsAvatarImagePipe,
    PriorityClassPipe,
    StatusClassPipe,
    StatusIconPipe,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes),
    PrimengModule,
    SharedModule,
    SharedPipesModule,
    InAppMessagingModule
  ],
  providers: [
    InAppMessageService,
    {
      provide: EXTERNAL_COMPONENTS,
      useValue: solutionComponents
    }
  ],
  exports: [
    InAppMessageComponent
  ]
})
export class InAppMessageModule { }
